/**
 * Retrieves the localized text based on the selected language.
 * @param data - The object containing multilingual text fields (e.g., { title_en, title_fr, title_ar }).
 * @param key - The base key of the text field (e.g., "title" or "description").
 * @param defaultLang - The default language to use if none is set in sessionStorage (default: "en").
 * @returns The localized text.
 */
export const getLocalizedText = (
  data: Record<string, any>,
  key: string,
  defaultLang = "en",
): string => {
  let selectedLanguage = defaultLang;

  // Check if we are running on the client side
  if (typeof window !== "undefined") {
    selectedLanguage = sessionStorage.getItem("language") || defaultLang;
  }

  return (
    data[`${key}_${selectedLanguage}`] || data[`${key}_${defaultLang}`] || ""
  );
};
